import {GetDegreeSatisfaction,GetTOPAttention,GetFeedbackAmounts,GetLiveData} from '@/api/Home'

const Home = {
  state : {},
  mutations: {},
  actions: {
    getDegreeSatisfaction({commit},params){
      return new Promise((resolve, reject) => {
        GetDegreeSatisfaction(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getTOPAttention({commit},params){
      return new Promise((resolve, reject) => {
        GetTOPAttention(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getFeedbackAmounts({commit},params){
      return new Promise((resolve, reject) => {
        GetFeedbackAmounts(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getLiveData({commit},params){
      return new Promise((resolve, reject) => {
        GetLiveData(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

  }
}
export default Home


// WEBPACK FOOTER //
// ./src/store/modules/Home.js


// WEBPACK FOOTER //
// ./src/store/modules/Home.js